/* eslint-disable max-len */
// /* eslint-disable max-len */
import React, { useState, useEffect, useContext } from 'react'
import { validateEmail } from '../../../../CommonMethods/EmailValidator';
import ErrorMessage from '../../../../components/ErrorMessage';
import GlobalContext from '../../../../components/Context/GloablContext';
import Loader from '../../../../components/Loader';
import { motion } from 'framer-motion'
import BannerImage from '../../../../components/BannerImage';
import AnimatedPage from '../../../../components/Animation/AnimatedPage';
import { dataService } from '../../../../services/data.services';
import { useDispatch } from 'react-redux';
import { resetState } from '../../../../redux/systemConfigSlice';
import HelpGuideModal from '../../../../components/HelpGuideModal';
import {useGetHelpGuideOrganizationLoginQuery} from '../../../../slices/patientSlice'

export default function SignIn({
    handleLoginCredentilas,
    emptyError,
    setEmptyError,
    email,
    password,
    error,
    seterror,
    handleLogin,
    loading,
    loginError,
    setIsForgotPassword
}
) {
    const [type, settype] = useState(true)
    const dispatch = useDispatch()
    const [invalidEmail, setInvalidEmail] = useState(false)
    const [invalidPassword, setInvalidPassword] = useState(false)
    const { setToastErrorMessage ,editSocket,setEditSocket} = useContext(GlobalContext)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const helguidedata = '/images/admin-login.png'

    function handleEmailChange(enteredEmail) {
        setInvalidEmail(validateEmail(enteredEmail));

    }
    const handleShowPassword = () => {
        settype(!type);
    }

    useEffect(() => {
        
        dispatch(resetState())
        
        // Only check for WebSocket-initiated logout (duplicate session termination)
        // Cross-tab logout shows toast directly in App.jsx (no flags needed)
        // WebSocket handler uses window.location.reload(), so we need a flag that persists
        const showLogoutToastRaw = localStorage.getItem('showLogoutToast');
        let showLogoutToast = null;
        
        if (showLogoutToastRaw) {
            try {
                const parsed = JSON.parse(showLogoutToastRaw);
                if (parsed && typeof parsed === 'object' && parsed.timestamp) {
                    // Check if timestamp is recent (within 10 seconds)
                    const isRecent = Date.now() - parsed.timestamp < 10000;
                    if (isRecent) {
                        showLogoutToast = parsed.value;
                    } else {
                        // Flag is stale, remove it
                        localStorage.removeItem('showLogoutToast');
                    }
                } else {
                    // Legacy format (plain string), use as-is
                    showLogoutToast = showLogoutToastRaw;
                }
            } catch (e) {
                // Not JSON, treat as legacy format (plain string)
                showLogoutToast = showLogoutToastRaw;
            }
        }
        
        // Only handle duplicate session termination (from WebSocket)
        // This happens when server forces logout via WebSocket and does window.location.reload()
        if (showLogoutToast === 'duplicate_session_terminated') {
            setToastErrorMessage('You have been logged out due to another login session');
            localStorage.removeItem('showLogoutToast');
        } else if (showLogoutToast && showLogoutToast !== 'true') {
            // Handle password update toast (also from WebSocket reload case)
            setToastErrorMessage(showLogoutToast);
            localStorage.removeItem('showLogoutToast');
        }
        
        // Check for account deactivated/timeout message (lower priority)
        const status = sessionStorage.getItem('custom-status')
        if (status === 'inactive' && status !== undefined) {
            setToastErrorMessage("You've been logged out, your account is deactivated or session timed out. Please log in again.")
        }
        
        //dispatch(usersList.util.resetApiState())
        sessionStorage.clear()
        
        // Close WebSocket if open
        if (editSocket && (editSocket.readyState === 1 || editSocket.readyState === 0)) {
            // Attempt to close the WebSocket
            editSocket.close();
            console.log("Attempting to close WebSocket...");
        
            // Set up an event listener to confirm the WebSocket has closed
            editSocket.onclose = (event) => {
                console.log("WebSocket closed successfully:", event);
                console.log("WebSocket state after close:", editSocket.readyState); // Should be 3 (CLOSED)
                // Perform any cleanup or additional logic here if needed
            };
        
            // Set up an event listener to catch any errors during the closing process
            editSocket.onerror = (error) => {
                console.error("WebSocket encountered an error during closing:", error);
            };
        
            // Use a timeout to check the WebSocket state after a delay
            setTimeout(() => {
                if (editSocket.readyState === 2) {
                    console.log("WebSocket is still in the process of closing...");
                } else if (editSocket.readyState === 3) {
                    console.log("WebSocket has successfully closed.");
                } else {
                    console.log("Unexpected WebSocket state:", editSocket.readyState);
                }
            }, 1000); // Wait 1 second before checking the state
        }

    }, [])

    return (
        <>
            <AnimatedPage>
                <div className='w-[35%] 2xl:w-[30%] pl-[30px] 2xl:pl-0'>

                    <div className='w-[290px] xl:[300px] 2xl:w-[330px] flex flex-col justify-center items-center h-screen'>

                        <div className='w-full'>

                            <img src="/images/Arcm_login_logo.png" alt="Banner-Img" className='w-fit h-fit mx-auto' />
                            <h1 className='mt-6 text-[36px] font-normal text-[#000] text-center'>Login</h1>
                            <div className='flex justify-center items-center'>
                                <h1 className='text-lg font-normal text-[#000] text-center'>Please enter your details to login </h1>
                                <span onClick={() => setHelpGuideModel(true)} className='ml-0.5 cursor-pointer'>
                                    <img src="/images/info.png" alt="icon" loading="lazy" decoding="async" />
                                </span> 
                            </div>
                            <form action="" className='mt-8' onSubmit={(e) => handleLogin(e)}>
                                <div className='flex flex-col'>
                                    <label htmlFor='email' className='text-xs font-semibold text-[#000] pb-1.5'>Username</label>
                                    {/* border-[#D3454D] */}
                                    <input type="text" id='userName'
                                        value={email}
                                        onChange={(e) => {
                                            handleLoginCredentilas('email', e.target.value)
                                            handleEmailChange(e.target.value)
                                        }}
                                        onFocus={() => {
                                            seterror(false)
                                            setToastErrorMessage("")
                                            setInvalidEmail(false)
                                            setEmptyError(false)
                                        }}
                                        style={{ border: `1px solid ${error || (emptyError && email.trim() === "") ? '#C81720' : '#C5C9DA'}` }}
                                        className='border border-[#C5C9DA] rounded-lg px-3.5 py-[11px] text-sm font-normal 
                                    text-[#000B17] w-full placeholder:text-[#52555D] outline-none focus:border-[#339D9E] 
                                    focus:shadow-s1' placeholder='Enter username' />
                                </div>
                                <div className='flex flex-col mt-4'>
                                    <label htmlFor='Username' className='text-xs font-semibold text-[#000] pb-1.5'>Password</label>
                                    <div className='relative'>
                                        <input type={type ? "password" : "text"} id='passWord'
                                            value={password}
                                            onFocus={() => {
                                                seterror(false)
                                                setToastErrorMessage("")
                                                setInvalidPassword(false)
                                                setEmptyError(false)
                                            }}
                                            style={{ border: `1px solid ${error || invalidPassword || (emptyError && password.trim() === "") ? '#C81720' : '#C5C9DA'}` }}
                                            onChange={(e) => {
                                                handleLoginCredentilas('password', e.target.value)
                                            }}
                                            className='border border-[#C5C9DA] rounded-lg pl-3.5 py-[11px] pr-[60px] text-sm 
                                        font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none
                                        focus:border-[#339D9E] focus:shadow-s1'
                                            autoComplete='off' placeholder='Enter password' />
                                        <button type='button' className='absolute top-1/2 right-3.5 -translate-y-[50%]'>
                                            <span onClick={() => handleShowPassword()} className='text-xs font-semibold text-[#008586]'>{type ? "SHOW" : "HIDE"}</span>
                                            <span className='text-xs font-semibold text-[#008586] hidden'>HIDE</span>
                                        </button>
                                    </div>
                                </div>
                                {error && <ErrorMessage error message={loginError} />}
                                {/* <p className='text-sm font-normal text-[#F04438] mt-4'>Incorrect username or password</p> */}
                                <button type='button' disabled={loading} onClick={() => setIsForgotPassword(true)} id="forgot" className='text-xs font-semibold text-[#008586] mt-3'>Forgot password</button>
                                <button type='submit'
                                    id="login"
                                    disabled={loading}
                                    className='w-full mt-8 py-2.5 px-2 text-lg font-semibold text-[#fff] rounded-[16px] 
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]'>
                                    {!loading ? 'Login' : <span>{<Loader />}</span>}
                                </button>
                            </form>
                        </div>

                    </div>

                </div>
            </AnimatedPage>
            {helpGuideModel &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                pdfUrl={helguidedata}
            />
            }
        </>
        

    )
}


